import React from "react";
import "./CollegeGrievanceCommittee.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const committeeMembers = [
  {
    srNo: "1",
    name: "Dr. Pravin Gundalwar",
    designation: "Director",
    contactNo: "67308301/02",
    email: "timscdr.director@thakureducation.org",
    remark: "Chairperson"
  },
  {
    srNo: "2",
    name: "Ms. Rupali Jadhav",
    designation: "Assistant Professor, Dy. HOD ACA",
    contactNo: "-",
    email: "rupali.jadhav@thakureducation.org",
    remark: "Member Secretary"
  },
  {
    srNo: "3",
    name: "Ms. Kinjal Doshi",
    designation: "Assistant professor, HOD-ACA",
    contactNo: "-",
    email: "kinjal.doshi@thakureducation.org",
    remark: "Member"
  }
];

const CollegeGrievanceCommittee = () => {
  return (
    <>
      <Navbar />
        <PageHeader 
                  title="College Grievance Redressal Committee" 
                  crumbs={[{ label: 'Home', href: '/' }, { label: 'College Grievance Redressal Committee' }]} 
                />
      <div className="cgc-page">
        <div className="cgc-container">
          <header className="cgc-header">
            <p className="cgc-overline">University of Mumbai Notification</p>
            <p className="cgc-subtitle">
              As per the University of Mumbai notification No. DSD.05/of 2005 the
              following College Grievance Redressal Committee is constituted in the
              institute for the purpose of Redressal grievance of the students.
            </p>
          </header>

          <section className="cgc-table-section" aria-label="College grievance committee members">
            <div className="cgc-table-wrap">
              <table className="cgc-table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Member</th>
                    <th>Designation</th>
                    <th>Contact No.</th>
                    <th>Email ID</th>
                    <th>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {committeeMembers.map((member) => (
                    <tr key={member.email}>
                      <td data-label="Sr. No.">{member.srNo}</td>
                      <td data-label="Member">{member.name}</td>
                      <td data-label="Designation">{member.designation}</td>
                      <td data-label="Contact No.">{member.contactNo}</td>
                      <td data-label="Email ID">
                        <a className="cgc-member-email" href={`mailto:${member.email}`}>
                          {member.email}
                        </a>
                      </td>
                      <td data-label="Remark">{member.remark}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section className="cgc-note-section" aria-label="Committee note">
            <p className="cgc-note-text">
              All are requested to take a note of the same &amp; cary out the duties
              as per the Institute guidelines in order to ensure natural justice to
              the stake holders.
            </p>
          </section>

          <section className="cgc-cta-panel" aria-label="Grievance registration">
            <p className="cgc-cta-text">
              In order to ensure transparency in the functioning of the Institute
              and to prevent any unfair practices, a Grievance Redressal Committee
              has been formed. Stakeholders are free to approach the Grievance
              Redressal Committee of the Institute or can register their grievance
              please click here.
            </p>

          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CollegeGrievanceCommittee;
